export const INVITATION_DISPLAY_STATUS = {
  pending: 'pending',
  expired: 'expired',
} as const;

export type InvitationDisplayStatus =
  (typeof INVITATION_DISPLAY_STATUS)[keyof typeof INVITATION_DISPLAY_STATUS];

export function resolveInvitationStatus(expiresAt: string, now: Date): InvitationDisplayStatus {
  const expiresAtTime = new Date(expiresAt).getTime();
  if (Number.isNaN(expiresAtTime) === true) {
    return INVITATION_DISPLAY_STATUS.pending;
  }
  return expiresAtTime < now.getTime()
    ? INVITATION_DISPLAY_STATUS.expired
    : INVITATION_DISPLAY_STATUS.pending;
}
